import $ from 'jquery';


$('.portraits-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
});

$('.evenements-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
});


$('.les-plus-lus-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    responsive: [
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 520,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});


var $territoiresSlider = $('.territoires-slider');
var isSlickInitialized = false; // Track whether the Slick slider is already initialized

function initSlick() {
    if (!isSlickInitialized) {
        $territoiresSlider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        arrows: true,
                    }
                }
            ]
        });
        isSlickInitialized = true;
    }
}

function destroySlick() {
    if (isSlickInitialized) {
        $territoiresSlider.slick('unslick');
        isSlickInitialized = false;
    }
}

// Initialize or destroy Slick slider based on screen width
function checkScreenSize() {
    if ($(window).width() <= 768) {
        initSlick();
    } else {
        destroySlick();
    }
}

// Initial check on document ready
checkScreenSize();

// Recheck on window resize with a debounce to avoid excessive calls
var resizeTimeout;
$(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(checkScreenSize, 250); // Adjust debounce time as needed
});



